import {
  JWTClaimsRole,
  permissionsEnumSchema,
  psychologistHeadlineEnumSchema,
} from "@mindlercare/schema";
import CONSTANTS from "core/constants";
import { Slot } from "../../core/types";

const NetherlandStrategy = {
  patientCardTabs: {
    BOOKINGS: CONSTANTS.PATIENT_CARD_TABS.BOOKINGS,
    ICBT: CONSTANTS.PATIENT_CARD_TABS.ICBT,
    PROMOCODES: CONSTANTS.PATIENT_CARD_TABS.PROMOCODES,
    ACTIONS: CONSTANTS.PATIENT_CARD_TABS.ACTIONS,
  },
  patientSearchFields: {
    FIRSTNAME: CONSTANTS.SEARCH_TERMS.FIRSTNAME,
    LASTNAME: CONSTANTS.SEARCH_TERMS.LASTNAME,
    USER_ID: CONSTANTS.SEARCH_TERMS.USER_ID,
    EMAIL: CONSTANTS.SEARCH_TERMS.EMAIL,
    NATIONAL_IDENTITY: CONSTANTS.SEARCH_TERMS.NATIONAL_IDENTITY,
  },
  psychologist: {
    userData: {
      rows: [
        CONSTANTS.PSYCHOLOGIST_ROW_COMBINATION_KEYS.EDITABLE_NAME,
        CONSTANTS.PSYCHOLOGIST_ROW_COMBINATION_KEYS
          .EDITABLE_PHONE_AND_UNEDITABLE_EMAIL,
        CONSTANTS.PSYCHOLOGIST_ROW_COMBINATION_KEYS.EDITABLE_BIG_CODE,
      ],
    },
    headlineKeys: [
      psychologistHeadlineEnumSchema.enum.basic,
      psychologistHeadlineEnumSchema.enum.gz,
      psychologistHeadlineEnumSchema.enum.clinical,
      psychologistHeadlineEnumSchema.enum.psychotherapist,
      psychologistHeadlineEnumSchema.enum.nursing_specialist,
    ],
    hasRequiredAdeli: false,
    hasPersonnummer: false,
  },
  specialities: {
    hasFilteredSpecialities: [
      "burn_out",
      "sexual_problems",
      "substance_use",
      "sleeping_disorder",
      "eating_disorders",
      "parental_support",
      "relationship_family_issues",
      "nl_mourning",
      "nl_adjustment_disorder",
      "nl_development_disorder",
    ],
  },
  slots: {
    isPayable: false,
  },
  marketHasStatisticsDashboard: false,
  slotTemplates: [
    CONSTANTS.SLOT_TEMPLATES.NEW_VISIT,
    CONSTANTS.SLOT_TEMPLATES.REVISIT,
    CONSTANTS.SLOT_TEMPLATES.ADVISORY_CONSULT,
    CONSTANTS.SLOT_TEMPLATES.TECH_TEST,
    CONSTANTS.SLOT_TEMPLATES.BLOCKER,
    CONSTANTS.SLOT_TEMPLATES.SUPERVISION,
    CONSTANTS.SLOT_TEMPLATES.EMDR,
    CONSTANTS.SLOT_TEMPLATES.DIAGNOSTICS_JOURNAL_ENTRY,
    CONSTANTS.SLOT_TEMPLATES.ADHD_SCREENING,
    CONSTANTS.SLOT_TEMPLATES.EVALUATION,
  ],
  patientCard: {
    status_label: "STATUS",
  },
  showEditPatientDetails: true,
  showRevisitLabelSuffix: false,
  showInsuranceInfoPsychologist: false,
  showInsuranceInfoAdmin: false,
  showInsurancePlan: false,
  showSavedCardStatus: false,
  showExtraInfoPatientBookings: false,
  showSessionCountColumn: false,
  changeSlotStatus: {
    enabled: true,
    enabledForRoles: [] as JWTClaimsRole[],
    enabledForPermission: permissionsEnumSchema.enum.EDIT_PATIENT_DETAILS,
    feeStatuses: [] as Slot["status"][],
    getSlotStatuses: () => {
      return CONSTANTS.UPDATABLE_BOOKING_STATUS;
    },
  },
  clinicalGuidelinesHref:
    "https://mindler.notion.site/Handboek-Mindler-NL-418d6e3d092947e8b74658ec87a70dc7",
};

export default NetherlandStrategy;
